import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./signature-field.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./signature-field.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, forwardRef, inject, Input, Output, ViewChild } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
let SignatureFieldComponent = class SignatureFieldComponent {
    signaturePad;
    options;
    quality;
    imageType;
    label;
    signatureChanged = new EventEmitter();
    _elementRef = inject(ElementRef);
    nativeElement;
    clearBtnLabel = "Clear";
    _signature;
    onChange;
    onTouched;
    get signature() {
        return this._signature;
    }
    set signature(value) {
        this._signature = value;
        this.signatureChanged.emit(value);
        this.onChange(this.signature);
    }
    constructor() {
        this.nativeElement = this._elementRef.nativeElement;
    }
    ngAfterViewInit() {
        // this.signaturePad is now available
        var t = this.nativeElement.offsetWidth;
        this.options.canvasWidth = t;
        //this.signaturePad.set("minWidth", 5); // set szimek/signature_pad options at runtime
        //this.signaturePad.set("width", t); // set szimek/signature_pad options at runtime
        this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
    writeValue(value) {
        this._signature = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    clear() {
        this.signaturePad.clear();
    }
    drawComplete(data) {
        if (data) {
            this.signature = this.signaturePad.toDataURL(this.imageType, this.quality);
        }
        else {
            this.signature = "";
        }
    }
    drawStart(event) {
        // will be notified of szimek/signature_pad's onBegin event
        // console.log("Start drawing", event);
    }
    static ctorParameters = () => [];
    static propDecorators = {
        signaturePad: [{ type: ViewChild, args: ["signature",] }],
        options: [{ type: Input }],
        quality: [{ type: Input }],
        imageType: [{ type: Input }],
        label: [{ type: Input }],
        signatureChanged: [{ type: Output }]
    };
};
SignatureFieldComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-signature-field",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SignatureFieldComponent),
                multi: true,
            },
        ],
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SignatureFieldComponent);
export { SignatureFieldComponent };
